import GLightbox from "glightbox";

GLightbox({
	selector: "data-glightbox",
	touchNavigation: true
});
